import BaseApiController from 'controller/baseresourcecontroller';
import logger from '@/plugins/logger.js';
export default class LicenseController extends BaseApiController {
  constructor() {
    super('mvc/license');
  }

  // Only in debug because the window.lic property is set in the centixweb site
  // And in debug this is not available
  async GetProductCode() {
    return super.Post('PrCode', {});
  }

   async Get() {
    return super.Post('Get', {});
  }
  async Save(data) {
    return super.Post('Save', data);
  }

  async GetActivatedModules() {
    return super.Post('ActivatedModules', {});
  }

  async Retrieve() {
    return super.Post('Retrieve', {});
  }
}
